import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import en from 'src/constants/en'
import { queryClient } from 'src/reactQuery'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewSentiment } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export interface UseChangeReviewSentimentParams {
  campaignId: string
  onError?: () => void
  onSuccess?: () => void
}

// Every review-analysis read derives sentiment metrics at request time, so once
// the override lands we refetch the reviews list and the sentiment-driven
// summaries (brand/facility overview, platform analysis) to reflect it.
const SENTIMENT_DEPENDENT_KEYS = [
  QueryKey.GET_REVIEW_ANALYSIS_REVIEWS,
  QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW,
  QueryKey.GET_REVIEW_ANALYSIS_FACILITY_OVERVIEW,
  QueryKey.GET_REVIEW_ANALYSIS_PLATFORM_ANALYSIS,
]

export const useChangeReviewSentiment = ({
  campaignId,
  onError,
  onSuccess,
}: UseChangeReviewSentimentParams) =>
  useMutation({
    mutationFn: ({
      ids,
      sentiment,
    }: {
      ids: string[]
      sentiment: ReviewSentiment
    }) =>
      ReviewAnalysisApiService.changeReviewSentiment(
        campaignId,
        ids,
        sentiment
      ),
    onError: () => {
      toast.error(en.CHANGE_SENTIMENT_TYPE_ERROR_MESSAGE)
      onError?.()
    },
    onSuccess: () => {
      SENTIMENT_DEPENDENT_KEYS.forEach((key) =>
        queryClient.invalidateQueries({ queryKey: [key] })
      )
      toast.success(en.CHANGE_SENTIMENT_TYPE_SUCCESS_MESSAGE)
      onSuccess?.()
    },
  })
